import counterpart from "counterpart";
import { initCommonTranslate } from 'Utils/languages';

export function setupExportList() {
  initCommonTranslate();

  const exportList = [
    {
      value: 'visible-columns',
      text: counterpart('globalTranslate.common.visibleColumns'),
    },
    {
      value: 'all-columns',
      text: counterpart('globalTranslate.common.allColumns'),
    },
  ];

  return exportList;
}

export function getFileTypes(permission) {
  const fileList = [];
  // fileList.push({
  //     "value": "pdf",
  //     "text": "PDF",
  //     "disabled": true
  //   });
    permission !== undefined && permission !== null && permission.queue.canExportToSheet && 
    fileList.push({
      "value": "csv",
      "text": "CSV",
      'disabled': false
    });
  return fileList;
}

export function getExportTypes() {
  const exportTypes = [
    {
      "value": "visible-columns",
      "text": counterpart('globalTranslate.export.visibleColumns'),
    },
    {
      "value": "all-columns",
      "text": counterpart('globalTranslate.export.allColumns'),
    }
  ];
  return exportTypes;
}

export default {
  setupExportList,
  getFileTypes,
  getExportTypes,
};
